import styled from "styled-components";


const SizedBox = styled.div`
    height: ${props => props.height || "0"};
    width: ${props => props.width || "0"};
`;

export default SizedBox;